export default "__VITE_ASSET__BY71HcCf__"